import { PluginKey } from '@databases/plugins';
import { isPluginEnabled } from '@databases/plugins/helper';
import { useMemo } from 'react';

interface UseCommentsVisibilityProps {
  versionId?: string;
}

interface UseCommentsVisibilityResult {
  isEnabled: boolean;
  shouldRenderCommentInReadView: boolean;
}

export const useCommentsVisibility = ({
  versionId,
}: UseCommentsVisibilityProps): UseCommentsVisibilityResult => {
  const isCommentsPluginEnabled = isPluginEnabled(PluginKey.COMMENTS);

  /*
   * versionId: if versionId exists, we are looking at version history, so we don't render comments
   */
  const shouldRenderCommentInReadView = useMemo(
    () => isCommentsPluginEnabled && !versionId,
    [versionId, isCommentsPluginEnabled]
  );

  if (!isCommentsPluginEnabled) {
    return {
      isEnabled: false,
      shouldRenderCommentInReadView: false,
    };
  }

  return {
    isEnabled: true,
    shouldRenderCommentInReadView,
  };
};
